import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/productlinks`;

// CREATE =>  POST: add a new link to the server
export function createLink(link) {
    return axios.post(API_URL, { ...link });
}

// READ
export function getAllLinks() {
    return axios.get(API_URL);
}

export function getPaginatedLinks(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getLinkById(linkId) {
    return axios.get(`${API_URL}/${linkId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findLinks(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the link on the server
export function updateLink(linkId, link) {
    return axios.put(`${API_URL}/${linkId}`, { ...link });
}


// DELETE => delete the link from the server
export function deleteLink(linkId) {
    return axios.delete(`${API_URL}/${linkId}`);
}
